module.exports = __webpack_public_path__ + "img/coin-use-2.ff7ad12b.jpg";